var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.data.dataSource.data.review ? _c('GGGroup', {
    attrs: {
      "prop": _vm.data.template.prop
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function () {
        return [_c('GGRowSlider', {
          attrs: {
            "list": _vm.data.dataSource.data.review,
            "offset-between-elements": 10
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref) {
              var el = _ref.el;
              return [_c('GGReviewCard', {
                attrs: {
                  "data": el
                }
              })];
            }
          }], null, false, 1385699611)
        })];
      },
      proxy: true
    }], null, false, 127560765)
  }) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }